import React from "react";
import Select from "../Select.tsx";
import {IItemsSelect} from "../../models/interfaces/selectItems.interface.ts";

interface CreateBySelectProps {
  assignees: IItemsSelect[];
  value: IItemsSelect | null;
  onChange: (value: IItemsSelect | null) => void;
}

const CreateBySelect: React.FC<CreateBySelectProps> = (
  {
    assignees,
    value,
    onChange,
  }: CreateBySelectProps) => {
  const handleChange = (selected: IItemsSelect | null) => {
    if (selected?.id === "all") {
      onChange(null);
    } else {
      onChange(selected);
    }
  };

  return (
    <Select
      className="w-full mr-3 md:w-full md:mr-0"
      classButton="h-11 rounded-full shadow-[inset_0_0_0_0.0625rem_#DADBDC] caption1 dark:shadow-[inset_0_0_0_0.0625rem_#2A2E2F] dark:bg-transparent"
      classOptions="min-w-full overflow-auto max-h-40"
      classIcon="w-5 h-5 fill-n-400/50"
      classArrow="dark:fill-n-400"
      icon="user-check"
      placeholder="Create By"
      items={assignees}
      value={value}
      onChange={handleChange}
    />
  );
};

export default CreateBySelect;